import { Link2, Loader2, Sparkles } from "lucide-react";
import { HOME } from "../constants/testIds";

export const UrlInput = ({ url, setUrl, onFetch, loading }) => {
  const handleKey = (e) => {
    if (e.key === "Enter" && !loading) onFetch();
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (text) setUrl(text.trim());
    } catch {}
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="glow-focus relative flex items-center gap-2 bg-[#0a0a0b]/80 backdrop-blur-xl border border-white/10 rounded-2xl p-2 pl-5 transition-colors duration-200">
        <Link2 className="w-5 h-5 text-zinc-500 shrink-0" />
        <input
          data-testid={HOME.urlInput}
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Вставь ссылку на Reel, Story или фото..."
          className="flex-1 bg-transparent outline-none py-4 text-base sm:text-lg placeholder:text-zinc-600 font-medium"
          spellCheck={false}
          autoComplete="off"
        />
        {!url && (
          <button
            type="button"
            onClick={handlePaste}
            className="hidden sm:inline-flex text-xs text-zinc-400 hover:text-white border border-white/10 hover:border-white/25 rounded-full px-3 py-1.5 mr-1 transition-colors duration-200"
          >
            Вставить
          </button>
        )}
        <button
          data-testid={HOME.fetchButton}
          onClick={onFetch}
          disabled={loading || !url.trim()}
          className="ig-gradient animated-gradient text-white font-semibold text-sm sm:text-base rounded-xl px-5 sm:px-7 py-3.5 disabled:opacity-40 disabled:cursor-not-allowed hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 shadow-[0_10px_40px_-10px_rgba(220,39,67,0.6)] flex items-center gap-2"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Загружаю</span>
            </>
          ) : (
            <>
              <Sparkles className="w-4 h-4" />
              <span>Найти</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
